import { AwsConfig as AwsConstants } from '../Constants';

import { IAudited } from '@interfaces/ehss/Audited';
import BaseService, { RequestInterface } from '../Base';
import IPagination from '@interfaces/IPagination';
import AuditedPaginationQuery from '@interfaces/ehss/audited-pagination-query';
import BasePaginationQuery from '@interfaces/base-pagination-query';

export default class AuditedService extends BaseService {
    constructor() {
        super(AwsConstants.API_EHSS, 'audited');
    }
    async paging(query: AuditedPaginationQuery, fields?: string[]): Promise<IPagination<IAudited>> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };

        if (query.unit) {
            params.queryStringParameters['unit'] = query.unit;
        }
        if (query.limit) {
            params.queryStringParameters['limit'] = query.limit;
        }
        if (query.offset) {
            params.queryStringParameters['offset'] = query.offset;
        }
        if (query.hasProcess != undefined) {
            if (!query.hasProcess) {
                params.queryStringParameters['hasProcess'] = query.hasProcess;
            }
        }
        if (query.hasNoAuditor != undefined) {
            params.queryStringParameters['hasAuditor'] = false;
        }
        if (query.auditWithoutAuditor != undefined) {
            params.queryStringParameters['hasAuditor'] = false;
        }
        if (query.search) {
            params.queryStringParameters['search'] = query.search;
        }
        if (query.hasAuditor != undefined) {
            params.queryStringParameters['hasAuditor'] = true;
        }
        if (query.process) {
            params.queryStringParameters['process'] = query.process;
        }

        const res = await super.get<IPagination<IAudited>>('', params);
        return res;
    }
    async getById(id: string, fields?: string[]): Promise<IAudited> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        const res = await super.get<IAudited>(id, params);
        return res;
    }

    async create(id: string): Promise<IAudited> {
        const res = await super.post<IAudited>(id);
        return res;
    }
    async updateById(id: string, data: IAudited): Promise<IAudited> {
        const params: RequestInterface = {
            body: data
        };
        const res = await super.put<IAudited>(id, params);
        return res;
    }
    async deleteById(id: string, query: BasePaginationQuery): Promise<void> {
        const params: RequestInterface = {
            queryStringParameters: []
        };
        if (query.force) {
            params.queryStringParameters['force'] = query.force;
        }
        await super.delete<void>(id, params);
    }

    async processAdd(unitId: string, id: string, process: string): Promise<IAudited> {
        const params: RequestInterface = {
            queryStringParameters: { unit: unitId }
        };
        const res = await super.patch<IAudited>(`${id}/process/${process}`, params);
        return res;
    }
    async processRemove(unitId: string, id: string, process: string): Promise<void> {
        const params: RequestInterface = {
            queryStringParameters: { unit: unitId }
        };
        await super.delete<void>(`${id}/process/${process}`, params);
    }
}
